import React, { useState, useEffect } from "react";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { format, parseISO } from "date-fns";
import { useSubheader } from "../../../_metronic/layout/_core/MetronicSubheader";
import axios from "axios";
import DataTable from "react-data-table-component";

const FilterComponent = ({ filterText, onClear, onFilter }) => (
  <>
    <input
      id="search"
      type="text"
      placeholder="Filtro"
      className="form-control"
      style={{ width: "200px" }}
      value={filterText}
      onChange={onFilter}
    />
  </>
);

export function Plans() {
  const columns = [

    {
      name: "Ações",
      selector: row => row.id,
      width: "90px",
      cell: row => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link to={`/plans/${row.gateway_id}`}>
            <button
              type="button"
              className="btn btn-icon btn-primary"
              title="Editar"
            >
              <i className="flaticon-edit"></i>
            </button>
          </Link>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    },
    {
      name: "Cadastrado em",
      selector: row => row.created_at,
      width: "150px",
      cell: row => (
        <div>{format(new Date(row.created_at), "dd/MM/yyyy HH:mm")}</div>
      ),
      sortable: true
    },
    {
      name: "Nome",
      selector: row => row.name,
      maxWidth: "350px",
      sortable: true
    },
    {
      name: "Status",
      selector: row => (row.active ? "Ativo" : "Inativo"),
      width: "100px"
    },
    {
      name: "Dias de trial",
      selector: row => `${row.trial_days} dias`,
      width: "100px"
    },
    {
      name: "Duração",
      selector: row => `${row.periodicity} dias`,
      width: "100px"
    },
    {
      name: "Valor",
      selector: row => `R$${row.amount}`,
      width: "100px"
    },
    {
      name: "Grupo de planos",
      selector: row => row.feature_group_name,
      width: "300px",
      cell: row => (
        <div title={`${row.feature_group_name}`}>{row.feature_group_name}</div>
      )
    }
  ];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );

  const fetchPlans = async page => {
    setLoading(true);
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/plans/?page=${page}&per_page=${perPage}&filter=${filterText}`
    );

    setData(response.data.data.data);
    setTotalRows(response.data.data.totalItems);
    setLoading(false);
  };

  const handlePageChange = page => {
    fetchPlans(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/plans/?page=${page}&per_page=${newPerPage}&filter=${filterText}`
    );

    setData(response.data.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={e => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    fetchPlans(1);
  }, []);

  useEffect(() => {
    fetchPlans(1);
  }, [filterText]);

  return (
    <>
      <h1 className="azul-cabecalho">Planos</h1>
      <p className="subheader-text mb-10">Listagem de todos os planos</p>
      <Link to="/plans/add">
        <button
          type="button"
          className="btn btn-icon btn-primary mb-10"
          style={{ width: "200px" }}
        >
          <i className="flaticon2-add"></i>&nbsp;&nbsp;Novo Plano
        </button>
      </Link>

      <div className="row mb-10">
        <div style={{ overflowX: "auto", width: "100%" }}>
          <DataTable
            columns={columns}
            data={data}
            progressPending={loading}
            pagination
            perPage={perPage}
            paginationServer
            paginationTotalRows={totalRows}
            paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
          />
        </div>
      </div>
    </>
  );
}
